import { CallAPI } from "../../apiManager/ApiCall";
import { basicURL } from "../../apiManager/APIConfig";
import {
  allQuestionURL,
  myQuestionURL,
  verifiedActivityPostsURL,
  verifiedActivityUsersURL,
} from "../../apiManager/APIConfig";
import { store } from "../store";

export const GetAllQuestionsCall = async (params = {}) => {
  try {
    const query = new URLSearchParams();
    Object.entries(params || {}).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") query.append(k, String(v));
    });
    const url = query.toString() ? `${allQuestionURL}?${query.toString()}` : allQuestionURL;
    const response = await CallAPI({ url, method: "GET" });
    return response || {};
  } catch (e) {
    return { status: 400, questions: [] };
  }
};

export const GetMyQuestionsCall = async () => {
  try {
    const response = await CallAPI({ url: myQuestionURL, method: "GET" });
    return response || {};
  } catch (e) {
    return { status: 400, questions: [] };
  }
};

export const CreateQuestionCall = async ({ body, file, slide_id }) => {
  try {
    const formData = new FormData();
    formData.append("title", "community");
    formData.append("body", body || "");
    formData.append("entity_type", "profQuestion");
    if (slide_id) formData.append("slide_id", String(slide_id));
    if (file) formData.append("file", file);

    const response = await CallAPI({
      url: allQuestionURL,
      method: "POST",
      formData,
    });
    return response || {};
  } catch (e) {
    return { status: 400, message: "Failed to create question" };
  }
};

export const GetQuestionDetailsCall = async (questionId) => {
  if (!questionId) return { status: 400 };
  try {
    const response = await CallAPI({
      url: `${allQuestionURL}/question_details/${questionId}`,
      method: "GET",
    });
    return response || {};
  } catch (e) {
    return { status: 400 };
  }
};

export const GetPublicQuestionDetailsCall = async (questionId) => {
  if (!questionId) return { status: 400 };
  try {
    const res = await fetch(`${basicURL}${allQuestionURL}/public/${questionId}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });
    const data = await res.json().catch(() => ({}));
    return data || {};
  } catch (e) {
    return { status: 400 };
  }
};

/** Public web: record one view (no auth). Sends Bearer if user is logged in on web. */
export const RecordPublicQuestionViewCall = async (questionId) => {
  if (!questionId) return { status: 400 };
  let country_code = "";
  try {
    const loc = new Intl.Locale(navigator.language || "en").maximize();
    const region = loc?.region;
    if (region && /^[A-Z]{2}$/i.test(String(region))) {
      country_code = String(region).toUpperCase();
    }
  } catch (_) {
    /* ignore */
  }
  try {
    const access_token = store.getState()?.auth?.access_token;
    const authHeader =
      access_token &&
      (access_token.startsWith("Bearer ") ? access_token : `Bearer ${access_token}`);
    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };
    if (authHeader) headers.Authorization = authHeader;
    const res = await fetch(`${basicURL}${allQuestionURL}/public/view`, {
      method: "POST",
      headers,
      body: JSON.stringify({
        question_id: String(questionId),
        ...(country_code ? { country_code } : {}),
      }),
    });
    const data = await res.json().catch(() => ({}));
    return { ...data, status: res.status };
  } catch (e) {
    return { status: 0 };
  }
};

export const AddCommentCall = async ({ question_id, comment, mentioned_users = [] }) => {
  try {
    const response = await CallAPI({
      url: `${allQuestionURL}/comment`,
      method: "POST",
      body: { question_id, comment, mentioned_users },
    });
    return response || {};
  } catch (e) {
    return { status: 400, message: "Failed to add comment" };
  }
};

export const DeleteCommentCall = async (commentId) => {
  if (!commentId) return { status: 400 };
  try {
    const response = await CallAPI({
      url: `${allQuestionURL}/comment/${commentId}`,
      method: "DELETE",
    });
    return response || {};
  } catch (e) {
    return { status: 400, message: "Failed to delete comment" };
  }
};

export const GetVerifiedActivityUsersCall = async (params = {}) => {
  try {
    const query = new URLSearchParams();
    Object.entries(params || {}).forEach(([k, v]) => {
      if (v !== undefined && v !== null && String(v).trim() !== "") {
        query.append(k, String(v));
      }
    });
    const url = query.toString()
      ? `${verifiedActivityUsersURL}?${query.toString()}`
      : verifiedActivityUsersURL;
    const response = await CallAPI({ url, method: "GET" });
    return response || {};
  } catch (e) {
    return { status: 400, users: [] };
  }
};

export const GetVerifiedActivityPostsCall = async (params = {}) => {
  try {
    const query = new URLSearchParams();
    Object.entries(params || {}).forEach(([k, v]) => {
      if (v !== undefined && v !== null && String(v).trim() !== "") {
        query.append(k, String(v));
      }
    });
    const url = query.toString()
      ? `${verifiedActivityPostsURL}?${query.toString()}`
      : verifiedActivityPostsURL;
    const response = await CallAPI({ url, method: "GET" });
    return response || {};
  } catch (e) {
    return { status: 400, posts: [] };
  }
};
